import React from 'react';
import { PropTypes } from 'prop-types';
import { selectVulnSelectedTab } from 'store/Contextualization/AssetDetail/selectors';
import { useSelector } from 'react-redux';
import TabWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/styled';

const Tabs = ({ onScroll, tabRef }) => {
  const selectedTab = useSelector(selectVulnSelectedTab);

  return (
    <TabWrapper ref={ tabRef } onScroll={ onScroll }>
      { selectedTab.component }
    </TabWrapper>
  );
};

Tabs.propTypes = {
  onScroll: PropTypes.func.isRequired,
  tabRef: PropTypes.object.isRequired
};

export default Tabs;
